<template>
    <div>
        Great! Your friend {{ notification.relations.referee.first_name }} has registered with MySwitchPro!
    </div>
</template>

<script>
export default {
    name: "RewardReceived",
    props: {
        notification: Object
    },
}
</script>
